import { get, post } from "../../../api";
import url from "../../../api/apisList";
import { userUpdateDetails } from "../../user-redux/action";
import * as types from "./actionTypes";

export const companyUpdateAction = (data) => {
  let apiUrl = url("company");
  return async (dispatch, getState) => {
    try {
      const existingImage = getState().userManagement?.user?.image;
      const imageToKeep = data.image || existingImage || "";

      let user = {
        ...data,
        linkedin_url: data.linkedin_url || data.linkedinURL || "",
      };

      const apiPayload = { ...user };
      if (imageToKeep) {
        user.image = imageToKeep;
      } else {
        delete user.image;
        delete apiPayload.image;
      }

      let res = await post(apiUrl, apiPayload);
      if (res) {
        dispatch({
          type: types.COMPANY_UPDATE_ACTION,
          payload: user,
        });
        user.companyid = res?.data?.companyid;
        dispatch(userUpdateDetails(user));
      }
    } catch (err) {
      dispatch({
        type: types.COMPANY_UPDATE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const resetAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.RESET,
    });
  };
};
